import {
    apiRequest,
    pensiunDetailApprovePeriod,
    pensiunApprovePeriod
} from "../../../../../services/adapters/kepegawaian/pensiunService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pensiunDetailApprovePeriod, {
            params: query
        }, true)
    }

    fetchSubmit = async (query) => {
        return await apiRequest("post", pensiunApprovePeriod, {
            params: query
        }, true)
    }
}

export default DetailRepository